import { useRecordContext } from 'react-admin'
import { resultUri } from '../../../env'
import { client } from '../../../providers/data/client'
import { labTestAdviceCodeDetail } from '../../../utils/constants'
export const Title = () => {
  const record = useRecordContext()

  return record && <p>Kit #{record.kitId}</p>
}

export const AdviceCodeDetailTable = () => {
  return (
    <div>
      <p>
        <b>Advice Codes</b>
      </p>
      <p>
        <i>
          Select advice code appropriate for the test result. This is the messaging delivered to the patient when they retrieve
          results.
        </i>
      </p>
      <table className="info-table">
        <tr>
          <th>AdviceCode</th>
          <th>When to Use</th>
          <th>Result Sent to Patient</th>
        </tr>
        {labTestAdviceCodeDetail.map((code, index) => {
          return (
            <tr key={index}>
              <td>
                <b>{code.value}</b>
              </td>
              <td>{code.use}</td>
              <td>{code.description}</td>
            </tr>
          )
        })}
      </table>
    </div>
  )
}

export const formatResultRetrieval = (kit) => {
  // Generate link to result retrieval site, which is:
  //
  //  resultRetrievalHost + '#' + hash
  //
  //  where 'hash' is:
  //    base64encoded(
  //      {
  //        kitId: kitId,
  //        resultRetrievalCode: resultRetrievalCode
  //      }
  //    )
  //

  var retrievalHash = btoa(
    JSON.stringify({
      kitId: kit.kitId,
      resultRetrievalCode: kit.resultRetrievalCode,
    })
  )
  var retrievalUrl = resultUri + '#' + retrievalHash
  // Show the code, then link
  return (
    <p>
      {kit.resultRetrievalCode}&nbsp;&nbsp;
      <a href={retrievalUrl} target="_blank" rel="noreferrer">
        <span className="fa-solid fa-address-card" aria-hidden="true"></span>&nbsp;Results
      </a>
    </p>
  )
}

export const fetchResultImages = async (kitId) => {
  const resultImages = await client().get(`kits/${kitId}/artifacts`)
  return resultImages.data
}
